import React from 'react';
import './ConsumerCategoriesSection.css';

function ConsumerCategoriesSection() {
  const categories = [
    {
      title: 'Beauty & Personal Care',
      description: 'Skincare, cosmetics, grooming products, and wellness items positioned for direct-to-consumer online retail channels. Strategic sourcing for quality and brand compliance.'
    },
    {
      title: 'Home & Lifestyle',
      description: 'Home décor, kitchenware, bedding, and lifestyle products for established retail distribution. Sourced for durability, design appeal, and multi-channel retail fit.'
    },
    {
      title: 'Outdoor & Sporting Goods',
      description: 'Equipment, apparel, and accessories for outdoor activities and sports enthusiasts. Distribution focused on performance retailers and online marketplace channels.'
    },
    {
      title: 'Event & Hospitality Supplies',
      description: 'Professional supplies, party goods, and hospitality products for bulk wholesale distribution. Reliable sourcing for B2B event and hospitality sector needs.'
    },
    {
      title: 'Confectionery & Impulse Products',
      description: 'Specialty foods, candies, snacks, and impulse-purchase items designed for retail shelf placement and online consumer channels. Volume sourcing with quality assurance.'
    },
    {
      title: 'General Merchandise',
      description: 'Diverse consumer products including stationery, tools, electronics accessories, and seasonal items. Comprehensive sourcing to support varied retail channel requirements.'
    }
  ];

  return (
    <section id="consumer-categories" className="consumer-categories-section">
      <div className="section-container">
        <div className="consumer-categories-header">
          <h2>Consumer Categories We Support</h2>
          <p>
            We maintain active wholesale relationships across diverse consumer product categories, 
            enabling suppliers and distributors to reach established online retail channels and marketplace partners.
          </p>
        </div>

        <div className="consumer-categories-grid">
          {categories.map((category, index) => (
            <div key={index} className="consumer-category-card">
              <h3>{category.title}</h3>
              <p>{category.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ConsumerCategoriesSection;
